<template>
  <BaseSelector
    class="genderSelector"
    :title="title"
    :options="options"
    :selectValue="selectValue"
    @selectChangeHandler="selectChangeHandler"
  ></BaseSelector>
</template>

<script>
import BaseSelector from '@/components/common/select/BaseSelector'

export default {
  props: {
    selectValue: {
      type: Number,
    },
  },
  data() {
    return {
      title: '性別:',
      options: [
        { value: 0, description: '男' },
        { value: 1, description: '女' },
      ],
    }
  },
  methods: {
    selectChangeHandler(value) {
      this.$emit('selectChangeHandler', value)
    },
  },
  components: {
    BaseSelector,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/common/select/GenderSelector.vue